import { routerMiddleware } from "connected-react-router";
import { createHashHistory } from "history";
import { applyMiddleware, compose, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/index";
import thunk from "redux-thunk";

import { gaTrackingMiddleware } from "./analytics/reducer";
import reducers from "./index";

export const browsHistory = createHashHistory({ basename: "/", hashType: "slash" });

export default function configureStore(preloadedState) {
  const middlewares = [thunk, routerMiddleware(browsHistory), gaTrackingMiddleware];
  const middlewareEnhancer = applyMiddleware(...middlewares);
  const composedEnhancers =
    process.env["REACT_APP_ENV"] === "production"
      ? compose(middlewareEnhancer)
      : composeWithDevTools(middlewareEnhancer);
  const store = createStore(reducers(browsHistory), preloadedState, composedEnhancers);

  return store;
}
